import { ValidationErrorItem } from "joi";

export class FetchError extends Error {
  status: number;
  details?: ValidationErrorItem[];

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}
